import React from "react";
import {
    iconPostazioneUfficio,
  iconStanzaMensa,
  iconStanzaParcheggio,
  iconStanzaRiunione,
} from "../../const/Planimetria/IconPlanimetria";

export default function handlerButtonRoom(idTipologiaStanza) {
  let icon;
  let styleIcon;
  switch (idTipologiaStanza) {
    case 1:
      icon = iconPostazioneUfficio;
      styleIcon = "button-typeroom-office"
      break;
    case 2:
      icon = iconStanzaRiunione;
      styleIcon = "button-typeroom-meetingRoom"
      break;
    case 3:
      icon = iconStanzaParcheggio;
      styleIcon = "button-typeroom-park"
      break;
    case 4:
      icon = iconStanzaMensa;
      styleIcon = "button-typeroom-cafeteria"
      break;
    default:
  }

  const element = React.cloneElement(icon,{
    className: styleIcon
  })

  return element;
}
